import { getTeams } from 'FormsUI/api/Teams';
function createAction(name) {
  return `@@teams/${name}`;
}
export const REQUEST_TEAMS = createAction('REQUEST_TEAMS');
export const RECEIVE_TEAMS = createAction('RECEIVE_TEAMS');
export const SUCCEED_GETTING_TEAMS = createAction('SUCCEED_GETTING_TEAMS');
export const FAILED_GETTING_TEAMS = createAction('FAILED_GETTING_TEAMS');
export function requestTeams() {
  return {
    type: REQUEST_TEAMS
  };
}
export function receiveTeams(receivedTeams) {
  return {
    type: RECEIVE_TEAMS,
    teams: receivedTeams
  };
}
export function succeedGettingTeams() {
  return {
    type: SUCCEED_GETTING_TEAMS
  };
}
export function failGettingTeams() {
  return {
    type: FAILED_GETTING_TEAMS
  };
}
export function fetchTeams() {
  return dispatch => {
    dispatch(requestTeams());
    getTeams().then(teams => {
      dispatch(succeedGettingTeams());
      dispatch(receiveTeams(teams));
    }).catch(() => {
      dispatch(failGettingTeams());
    });
    return undefined;
  };
}